//Imports node_modules
import React, { useContext } from "react"

//Imports Css
import './CttCard.css'

import startImg from './StartProdution.svg'
import stopIMg from './StopProdution.svg'

//Imports Components

//Import Data
import { globalFunctions } from '../../../data/GlobalFunctions'

//Este Botão foi principlamente feito para evitar duplo click, detetar micro deslizes de dedos, touch and click events
const CttCard = (params) => {

    //--- Variaveis
    const {
        advancedClick,
    } = useContext(globalFunctions);

    function renderCover() {
        return (
            <div className="cover" style={{ background: params.ctt.cttColor }}></div>
        )
    }

    return (
        <div key={params.ctt.nctt} className="col-md-3 col-sm-3">
            <div className="card-container manual-flip">
                <div
                    className="card"
                    onClick={e => advancedClick(e, (e => params.onClick(params.ctt)))}
                    onTouchStart={e => advancedClick(e, (e => params.onClick(params.ctt)))}
                    onTouchEnd={e => advancedClick(e, (e => params.onClick(params.ctt)))}
                    onMouseDown={e => advancedClick(e, (e => params.onClick(params.ctt)))}
                    onMouseUp={e => advancedClick(e, (e => params.onClick(params.ctt)))}
                >
                    <div className="front">
                        {renderCover()}
                        <div className="customBranded" style={{ padding: '13.5px' }}>
                            <img src={params.ctt.productionCount > 0 ? stopIMg : startImg} alt="CogWheel" style={{ height: '66px', width: '66px' }} />
                        </div>
                        <div className="content">
                            <div className="main">
                                <h2 className="use-for" style={{ color: '#4C4C4D', marginTop: '0px', marginBottom: '1px' }}>{"[" + params.ctt.nctt + "]"}</h2>
                                <h2 className="use-for" style={{ color: '#4C4C4D', marginTop: '0px' }}>{params.ctt.nmctt}</h2>
                            </div>
                        </div>
                    </div>

                    {/* Ele precisa desta secção pois o original permitia virar a card, como limpei o conteudo tenho que meter uma largura minima*/}

                    <div className="back">
                        <div className="header">
                        </div>
                        <div className="content">
                            <div style={{ minWidth: '190px' }}></div>
                        </div>
                        <div className="footer">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CttCard